export function mergeArrayField<K>(existing = [], incoming: K[]): K[] {
  return [...existing, ...incoming]
}
